import { Sounds } from '../../sounds';
import { TutorialSteps } from '../../prefabs/game/Tutorial';
import {Level, LevelMapName, LevelName} from './level';

export const Level4: Level = {
  id:LevelName.Level4,
  //smash levels are how many crates need to be smashed to reach X star goals
  smashLevels:{
    smashLevels: [40,65,90]
  },
  //target score is how many crates need to be smashed to unlock the next level
  targetScore:40,
  levelMap:LevelMapName.Level4,
  levelBackground:"bg-desert.jpg",
  gameplayBackground:"gameplay-desert.png",
  levelBackgroundAtlas:"game-desert",
  friction:0.99,
  lives: 3,
  bumperDownKey:"bumper-down-desert.png",
  tutorialStep:[TutorialSteps.None],
  arrowColor:0x793223,
  bgMusic:Sounds.Track.DesertMusicLoop
}
